import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import {
    TablePagination,
    TableFooter,
    Button,
    Stack,
    Input,
    Paper,
    TableBody,
    TableRow,
    TableHead,
    TableContainer,
    TableCell,
    tableCellClasses,
    Table,
    TextField,
    Grid,
    InputAdornment,
    FormControl,
    FilledInput,
    InputLabel
} from '@mui/material';

import { makeStyles } from '@material-ui/styles';

import {
    deleteContact,
    getMyContacts
} from '../../../paymentRequest';
import { useDispatch, useSelector } from 'react-redux';
import { hideApiLoader, showApiLoader } from '../../../../redux/tool-webjam/actions';
import toast from 'react-simple-toasts';
import { messages } from '../messages';
import { usePrevious, ValidateEmail } from '../../../Utils';
import ConfirmationAlert from '../ConfirmationAlert';
import CreateContact from './CreateContact';
import UpdateContact from './UpdateContact';
import GroupList from './GroupList';
import { setPaymentContact } from '../payment-reducer/actions';
import { paginationObject, SEARCH_DELAY_TIME } from '../Utils';
import { FEATURE_CUSTOM_PAYMENT } from '../../../../constant';
import SearchInput from '../helperComponent/SearchInput';
import MuiCheckMark from '../helperComponent/MuiCheckMark';
import { ct } from '../../../../constant-Utils';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "var(--theme-primary-color)",
        color: theme.palette.common.white,
        fontSize: 16,

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 16,
        wordBreak: "break-word",
        maxWidth: "500px"
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const useStyles = makeStyles({
    deleteButton: {

    },
    updateButton: {
        fontSize: "14px !important",
        backgroundColor: "#31ABB1 !important",
        color: "#fff !important",
        borderColor: "#31ABB1 !important",
        "&:hover": {
            backgroundColor: "#31ABB1 !important",
            color: "#fff !important",
            borderColor: "#31ABB1 !important"
        }
    }
})

function ContactList(props) {

    const classes = useStyles()

    const [page, setPage] = useState(0)
    const [pageNo, setPageNo] = useState({
        currentPage: 0,
        nextPage: 0,
        prevPage: 0
    })
    const [totalRecord, setTotalRecord] = useState(0)
    const [recordPerPage, setRecordPerPage] = useState(10)
    const [list, setList] = useState([])
    const [updateId, setUpdateId] = useState('')
    const [isConfirming, setIsConfirming] = useState(false)
    const [isCreateContactOpen, setIsCreateContactOpen] = useState(false)
    const [isUpdateContactOpen, setIsUpdateContactOpen] = useState(false)
    const [updateEmail, setUpdateEmail] = useState('')
    const [pageSearch, setPageSearch] = useState("")
    const dispatch = useDispatch();


    const {
        paymentContact
    } = useSelector(state => state[FEATURE_CUSTOM_PAYMENT])


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = (event) => {
        const { target } = event;
        setRecordPerPage(+target.value);
        setPage(0);
    }

    useEffect(() => {
        fetchData()
    }, [])

    // Page change pagination
    const prevPage = usePrevious(page);
    useEffect(() => {
        let p = 0;
        if (prevPage != undefined && prevPage < page) {
            p = pageNo.nextPage;
        } else if (prevPage != undefined && prevPage > page) {
            p = pageNo.prevPage;
        }
        if (prevPage != undefined && p > 0) {
            fetchData('', "?page=" + p + "&limit=" + recordPerPage)
        }
    }, [page])


    // Handle number of record per page
    const prevPerPage = usePrevious(recordPerPage);
    useEffect(() => {
        if (prevPerPage != undefined && prevPerPage != recordPerPage) {
            fetchData('', "?page=" + 1 + "&limit=" + recordPerPage)
        }
    }, [recordPerPage])

    const handleSearch = (e, isEmpty = false) => {
        setPageSearch(isEmpty ? "" : e?.target?.value)
    }

    let prevSearch = usePrevious(pageSearch)
    useEffect(() => {
        if (prevSearch != undefined) {
            var e = setTimeout(() => {
                fetchData();
            }, SEARCH_DELAY_TIME)
            return () => clearTimeout(e)
        }
    }, [pageSearch])

    // handle page when user create contact and close the pop up auto matically


    const fetchData = (data = {}, pagination = "?page=1&limit=10") => {
        dispatch(showApiLoader())

        data = Object.assign({
            search: pageSearch
        }, data)

        getMyContacts(data, pagination)
            .then(res => {
                dispatch(hideApiLoader())
                if (res.status == 1) {
                    let data = res.data.data;

                    dispatch(setPaymentContact({
                        list: data.contact,
                        pagination: data.pagination
                    }))
                    setTotalRecord(data.pagination.count)
                    setRecordPerPage(data.pagination.page.perPage)
                    setPageNo(data.pagination.page)
                } else {
                    dispatch(setPaymentContact({
                        list: [],
                        pagination: paginationObject
                    }))
                    setTotalRecord(0)
                    setRecordPerPage(10)
                    setPageNo({
                        currentPage: 0,
                        nextPage: 0,
                        prevPage: 0
                    })
                }
            })
    }

    const handleAction = (id, type, email = '') => {
        // type 1 for update, 0 for delete
        setUpdateId(id)
        if (type == 0) {
            setIsConfirming(true)
        } else {
            setUpdateEmail(email)
            setIsUpdateContactOpen(true)
        }
    }

    const handleConfirmAction = (type) => {
        let data = {
            id: updateId
        }
        setUpdateId('')

        setIsConfirming(false);
        if (type == true) {
            dispatch(showApiLoader())

            deleteContact(data).then(async res => {
                dispatch(hideApiLoader())
                if (res.status == 1) {
                    fetchData()
                    let msg = await dynamicMessageLocale(res.data.message);
                    toast(msg)
                } else if (res.error == 400) {
                    if (res.data?.message) {
                        let msg = await dynamicMessageLocale(res.data.message);
                        toast(msg)
                    } else {
                        toast(ct("rta-trmc.dashboard.subscription.failed"))
                    }
                }
            })
        }
    }

    const handleContactCreate = (type, isRefresh = 0) => {
        setIsCreateContactOpen(type)
        if (isRefresh == 1) {
            fetchData()
        }
    }
    const handleContactUpdate = (type, isRefresh = 0) => {
        if (isRefresh == 1) {
            fetchData()
        }
        setIsUpdateContactOpen(false)
    }

    return (
        <>
            {isConfirming && <ConfirmationAlert handleConfirmAction={handleConfirmAction} title={ct("rta-trmc.dashboard.subscription.deleteConfirm") + " contact?"} />}
            {isCreateContactOpen && <CreateContact handleContactCreate={handleContactCreate} title={"Add Contact"} />}
            {isUpdateContactOpen && <UpdateContact
                handleContactUpdate={handleContactUpdate}
                title={"Update Contact"}
                id={updateId}
                updateEmail={updateEmail}
            />}

            <Grid container spacing={2}
                sx={{
                    marginBottom: "20px"
                }}
                className="payment-contact-list-container"
            >
                <Grid item
                    xs={12}
                    md={6}
                    lg={6}
                    sm={6}
                    className="text-left"
                >
                    <Button variant="contained"
                        onClick={() => handleContactCreate(true)}
                        sx={{
                            fontSize: 14,
                            backgroundColor: "var(--theme-primary-color)"
                        }}
                        className="p-theme-btn"
                    >Add Contact</Button>
                </Grid>
                <Grid item
                    xs={12}
                    md={6}
                    lg={6}
                    sm={6}
                >
                    <SearchInput
                        pageSearch={pageSearch}
                        handleSearch={handleSearch}
                        classes="pull-right"
                    />
                </Grid>
            </Grid>
            <TableContainer className={"contact-list-container"}>
                <Table aria-label="customized table" stickyHeader={true} hover={"true"} >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Contact Mail</StyledTableCell>
                            <StyledTableCell>Actions</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {paymentContact.list.map((row, i) => (
                            <StyledTableRow key={(row.email + i)}>
                                <StyledTableCell
                                    sx={{
                                        width: "80%"
                                    }}
                                >{row.email}</StyledTableCell>
                                <StyledTableCell
                                    sx={{
                                        width: "20%",
                                        minWidth: "300px"
                                    }}
                                >
                                    <Stack direction="row" spacing={2}>
                                        <Button variant="contained"
                                            className="p-theme-btn mn-w-110"
                                            sx={{
                                                fontSize: 14
                                            }}
                                            onClick={() => handleAction(row._id, 1,row.email)}
                                        >
                                            <MuiCheckMark />
                                            Update</Button>

                                        <Button
                                            variant="contained"
                                            color="error"
                                            className='mn-w-110'
                                            // className="p-theme-outline-btn"
                                            sx={{
                                                fontSize: 14
                                            }}
                                            onClick={() => handleAction(row._id, 0)}
                                        >
                                            <i className='fa fa-trash-o payment-theme-icon'></i>
                                            Delete</Button>
                                    </Stack>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50]}
                                count={totalRecord}
                                rowsPerPage={recordPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                sx={{
                                    fontSize: 16
                                }}
                                SelectProps={{
                                    MenuProps: { classes: { paper: "invite-pagination" } }
                                }}
                                className="invite-pagination"
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        </>
    );
}


export default ContactList;